import { ActivityReport } from '../../../shared';
import { dataMember, required } from 'santee-dcts';
import { deserializers } from '../../../core';
import { Moment } from 'moment';

export class AdminTrainingMaterialActivityReport extends ActivityReport {
    @dataMember()
    @required()
    public reportId: number;

    @dataMember()
    @required()
    public subcategoryTitle: string;

    @dataMember()
    @required()
    public sponsorName: string;

    @dataMember()
    @required({ nullable: true })
    public protocolName: string;

    @dataMember()
    @required({ nullable: true })
    public siteName: string;

    @dataMember()
    @required({ nullable: true })
    public siteNum: string;

    @dataMember()
    @required({ nullable: true })
    public country: string;

    @dataMember()
    @required({ nullable: true })
    public title: string;

    @dataMember()
    @required({ nullable: true })
    public userName: string;

    @dataMember()
    @required({ nullable: true })
    public email: string;

    @dataMember()
    @required({ nullable: true })
    public blindingRole: string;

    @dataMember()
    @required({ nullable: true })
    public studyRole: string;
}